<template>
    <Mainpage :storeid="storeid">
      <div class="giftcard-wrapper">
        <GiftCard
          :imageUrlList="imageUrlList"
          title="The Perfect Foodie Gift for Every Occasion!"
          subtitle="get the gift of food delivery for yourself or a friend!"
          :cardValues="cardValues"
          :storeid="storeid"
        />
      </div>
    </Mainpage>
</template>

<script lang="ts">

import GiftCard from "./GiftCard.vue";
import Mainpage from "./Mainpage.vue";
import { mapMutations } from "vuex";

export default({
  components: { GiftCard , Mainpage},
  props: {
    storeid: {
      type: String,
      default: ""
    }
  },
  data(){
    return {
      imageUrlList: [
        "card1.png",
        "card2.png",
        "card3.png",
        "card4.png",
      ],
      cardValues: [5, 10, 20],
      cardContentList: [
        "Congratulations",
        "Thank you",
        "Happy Birthday",
        "Love you",
      ],
    }
  },
  mounted(){
    this.setStoreLoaded();
  },
  methods: {
    ...mapMutations(["setStoreLoaded"]),
  }
  
});
</script>

<style scoped>

.gift-card-button {
  background-color: #ffffff;
  font-family: Open Sans;
  margin-top: 1%;
  color: black;
  position: absolute;
  right: 13.8%;
  padding: 5px;
  border-radius: 5px;
}
.giftcard-wrapper {
  height: 92%;
  /* width: 100%; */
  width: 580px;
  padding: 2% 0;
  margin: 0 auto;
  box-sizing: border-box;
}




@media only screen and (max-width: 900px) {
  .logo-icon {
    height: 90px;
    margin-left: -9px;
  }
  .gift-card-button {
    top: 20px;
    right: 0;
    color: #55a7ff;
  }

  .giftcard-wrapper {
    width: 100%;
  }
}

@media only screen and (max-width: 600px) {
  .logo-icon {
    height: 70px;
    margin-left: -9px;
  }
}


</style>
